export default [{
  test: (parentCard, childCard) => {
    if (childCard.startDate && parentCard.startDate && childCard.startDate < parentCard.startDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_CHILD_START_DATE_BEFORE_PARENT_START_DATE',
        relationType: 'child',
        parentId: parentCard.id,
        parentDateType: 'startDate',
        parentDate: parentCard.startDate,
        childId: childCard.id,
        childDateType: 'startDate',
        childDate: childCard.startDate,
      }
    }
  },
}, {
  test: (parentCard, childCard) => {
    if (childCard.dueDate && parentCard.startDate && childCard.dueDate < parentCard.startDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_CHILD_DUE_DATE_BEFORE_PARENT_START_DATE',
        relationType: 'child',
        parentId: parentCard.id,
        parentDateType: 'startDate',
        parentDate: parentCard.startDate,
        childId: childCard.id,
        childDateType: 'dueDate',
        childDate: childCard.dueDate,
      }
    }
  },
}, {
  test: (parentCard, childCard) => {
    if (childCard.startDate && parentCard.dueDate && childCard.startDate > parentCard.dueDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_CHILD_START_DATE_AFTER_PARENT_DUE_DATE',
        relationType: 'child',
        parentId: parentCard.id,
        parentDateType: 'dueDate',
        parentDate: parentCard.dueDate,
        childId: childCard.id,
        childDateType: 'startDate',
        childDate: childCard.startDate,
      }
    }
  },
}, {
  test: (parentCard, childCard) => {
    if (childCard.dueDate && parentCard.dueDate && childCard.dueDate > parentCard.dueDate) {
      return {
        formattedMessageId: 'CARD_DATE_CONFLICT_CHILD_DUE_DATE_AFTER_PARENT_DUE_DATE',
        relationType: 'child',
        parentId: parentCard.id,
        parentDateType: 'dueDate',
        parentDate: parentCard.dueDate,
        childId: childCard.id,
        childDateType: 'dueDate',
        childDate: childCard.dueDate,
      }
    }
  },
}]
